// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-d6375df0] {\n  font-size: 1rem;\n  font-weight: bold;\n  text-align: center;\n  color: #11291B;\n}\np[data-v-d6375df0] {\n  color: #11291B;\n}", ""]);
// Exports
module.exports = exports;
